// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255,255,255,.95);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--border);
  box-shadow: 0 1px 3px rgb(0 0 0 / .06);
}

.navbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 68px;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: var(--text);
}
.brand-icon { font-size: 1.5rem; }
.brand-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--primary);
  letter-spacing: -.02em;
}

.navbar-links {
  display: flex;
  align-items: center;
  gap: 4px;
  list-style: none;
}
.navbar-links li a,
.navbar-links li button {
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: var(--radius-sm);
  font-size: .9rem;
  font-weight: 500;
  color: var(--text);
  background: none;
  border: none;
  text-decoration: none;
  transition: background .15s, color .15s;
}
.navbar-links li a:hover { background: var(--surface); color: var(--primary); text-decoration: none; }
.navbar-links .btn { padding: 8px 18px; }

.navbar-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
}
.navbar-toggle span {
  display: block;
  width: 24px; height: 2px;
  background: var(--text);
  border-radius: 2px;
}

@media (max-width: 768px) {
  .navbar-toggle { display: flex; }
  .navbar-links {
    display: none;
    position: absolute;
    top: 68px; left: 0; right: 0;
    flex-direction: column;
    background: var(--white);
    border-bottom: 1px solid var(--border);
    padding: 12px 24px 20px;
    gap: 2px;
    box-shadow: var(--shadow);
  }
  .navbar-links.open { display: flex; }
  .navbar-links li { width: 100%; }
  .navbar-links li a, .navbar-links li button { width: 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;AACpB;AACA,cAAc,iBAAiB,EAAE;AACjC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,uCAAuC;AACzC;AACA,2BAA2B,0BAA0B,EAAE,qBAAqB,EAAE,qBAAqB,EAAE;AACrG,qBAAqB,iBAAiB,EAAE;;AAExC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW,EAAE,WAAW;EACxB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB,aAAa,EAAE;EAChC;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS,EAAE,OAAO,EAAE,QAAQ;IAC5B,sBAAsB;IACtB,wBAAwB;IACxB,sCAAsC;IACtC,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;EAC3B;EACA,qBAAqB,aAAa,EAAE;EACpC,mBAAmB,WAAW,EAAE;EAChC,8CAA8C,WAAW,EAAE;AAC7D","sourcesContent":[".navbar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: rgba(255,255,255,.95);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid var(--border);\n  box-shadow: 0 1px 3px rgb(0 0 0 / .06);\n}\n\n.navbar-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 68px;\n}\n\n.navbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n  color: var(--text);\n}\n.brand-icon { font-size: 1.5rem; }\n.brand-name {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--primary);\n  letter-spacing: -.02em;\n}\n\n.navbar-links {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  list-style: none;\n}\n.navbar-links li a,\n.navbar-links li button {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 14px;\n  border-radius: var(--radius-sm);\n  font-size: .9rem;\n  font-weight: 500;\n  color: var(--text);\n  background: none;\n  border: none;\n  text-decoration: none;\n  transition: background .15s, color .15s;\n}\n.navbar-links li a:hover { background: var(--surface); color: var(--primary); text-decoration: none; }\n.navbar-links .btn { padding: 8px 18px; }\n\n.navbar-toggle {\n  display: none;\n  flex-direction: column;\n  gap: 5px;\n  background: none;\n  border: none;\n  padding: 6px;\n  cursor: pointer;\n}\n.navbar-toggle span {\n  display: block;\n  width: 24px; height: 2px;\n  background: var(--text);\n  border-radius: 2px;\n}\n\n@media (max-width: 768px) {\n  .navbar-toggle { display: flex; }\n  .navbar-links {\n    display: none;\n    position: absolute;\n    top: 68px; left: 0; right: 0;\n    flex-direction: column;\n    background: var(--white);\n    border-bottom: 1px solid var(--border);\n    padding: 12px 24px 20px;\n    gap: 2px;\n    box-shadow: var(--shadow);\n  }\n  .navbar-links.open { display: flex; }\n  .navbar-links li { width: 100%; }\n  .navbar-links li a, .navbar-links li button { width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
